import actionTypes from '../constants/action-types';

const isScrolling = (state = false, action) => {
  if (action.type !== actionTypes.SET_SCROLL_STATUS) return state;

  return action.payload.isScrolling;
};

export default isScrolling;
